import { useFormContext, useWatch } from 'react-hook-form';
import { useCallback, useEffect } from 'react';

export const NOMINATION_NOMINATOR_ORG_CONSENT_KEY = 'nomination.nominator.shareInfoWithOrgConsent';

export const useShareNominatorOrgConsent = (shareNominatorInfoWithOrg: boolean) => {
  const { setValue } = useFormContext();
  const shareNominatorOrgConsent = useWatch({ name: NOMINATION_NOMINATOR_ORG_CONSENT_KEY });

  const toggleShareNominatorOrgConsent = useCallback(() => {
    setValue(NOMINATION_NOMINATOR_ORG_CONSENT_KEY, !shareNominatorOrgConsent);
  }, [shareNominatorOrgConsent, setValue]);

  useEffect(() => {
    if (shareNominatorInfoWithOrg) {
      // Initialise to true by default
      setValue(NOMINATION_NOMINATOR_ORG_CONSENT_KEY, true);
    }
  }, [shareNominatorInfoWithOrg, setValue]);

  return {
    shareNominatorOrgConsent,
    toggleShareNominatorOrgConsent,
  };
};
